import { useHttp } from "./useHttp";
import { useDispatch } from "react-redux";
import { createSetVehicleTypesDataAction } from "../actions/dataActions";

export const useVehicleTypeData = (params, dataFresh) => {
  const dispatch = useDispatch();
  const [data, loading, error] = useHttp(
    "vehicletype",
    "get",
    params,
    dataFresh
  );
  if (error) {
    throw Error("There was an error");
  }

  if (!loading && data !== null) {
    dispatch(createSetVehicleTypesDataAction(data));
  }

  return !loading;
};
